export default "__VITE_ASSET__Dpbv7Qhk__"